export const PRODUCT_CONTENT_GET_SUCCESS = 'PRODUCT_CONTENT_GET_SUCCESS';
export const PRODUCT_CONTENT_GET_ERROR = 'PRODUCT_CONTENT_GET_ERROR';
export const IRIS_RETURNS_CONTENT_REQUEST = 'IRIS_RETURNS_CONTENT_REQUEST';
export const IRIS_CONTENT_GET_REQUEST = 'IRIS_CONTENT_GET_REQUEST';
